import { api } from '../../plugins/api';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    telepratique: {
			id: '',
			demandeAdmission: '',
			demandeInscription: '',
			pp: '',
    }
  }
}

const state = getDefaultState()

const getters = {
  GET_TELEPRATIQUE: (state) => { return state.telepratique },
}

const mutations = {
	SET_TELEPRATIQUE (state, telepratique) {
    state.telepratique = { ...telepratique }
	},
	UPDATE_TELEPRATIQUE(state, telepratique) {
    state.telepratique = telepratique
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async getTelepratiqueByDemandeInscriptionId ({ commit }, demandeInscriptionId) {
		const response = await api.get(`telepratique/demandesinscriptions/` + demandeInscriptionId);
		commit("SET_TELEPRATIQUE", response.data && response.data[0] ? response.data[0] : getDefaultState().telepratique)
	},
	async updateTelepratique ({ commit }, telepratique) {
		const response = await api.put(`telepratique`, telepratique);
		commit("UPDATE_TELEPRATIQUE", response.data)
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})